import { ReactElement } from 'react';
import { useUpdateEffect } from 'react-use';

import {
   AppointmentDetailsQuery,
   AppointmentSlotScheduleQuery,
   AppointmentUpdatePresenceConfirmedCommand,
} from '@dreryk/egabinet-appointment-frontend-api';
import { AppointmentId } from '@dreryk/egabinet-appointment-published-language-api';

import { Toggle } from '@dreryk/react-components';
import { useFormController } from '@dreryk/react-common';
import { refetchCqrsQuery, useCqrsCommand } from '@dreryk/command-query-react-common';

const DEFAULT_APPOINTMENT_STATUS = false;

type AppointmentConfirmationStatusToggleFormBean = {
   confirmed: boolean;
};

type AppointmentConfirmationStatusToggleProps = {
   initialConfirmed: boolean | undefined;
   appointmentId: number;
};

export const AppointmentConfirmationStatusToggle = (props: AppointmentConfirmationStatusToggleProps): ReactElement => {
   const { register, watch } = useFormController<AppointmentConfirmationStatusToggleFormBean>({
      confirmed: props.initialConfirmed ?? DEFAULT_APPOINTMENT_STATUS,
   });

   const currentConfirmed = watch('confirmed');

   const { execute: updateAppointmentPresenceConfirmationStatus } = useCqrsCommand<
      void,
      AppointmentConfirmationStatusToggleFormBean
   >(
      (parameters) => {
         const command = new AppointmentUpdatePresenceConfirmedCommand();
         command.presenceConfirmed = parameters.confirmed;
         command.id = AppointmentId.of(props.appointmentId);
         return command;
      },
      {
         onSuccess: () => {
            refetchCqrsQuery(AppointmentDetailsQuery);
            refetchCqrsQuery(AppointmentSlotScheduleQuery);
         },
      }
   );

   useUpdateEffect(() => {
      updateAppointmentPresenceConfirmationStatus({ confirmed: currentConfirmed });
   }, [currentConfirmed]);

   // TODO DREGAB-24646 Zmienić na <form onInput ...>...</form>
   return <Toggle testId={'appointmentConfirmationStatus'} controller={register('confirmed')} />;
};
